module.exports = __webpack_public_path__ + "img/icon-location.2fa92730.svg";